export enum GrantTypes {
  client_credentials = 'client_credentials',
  // ['password', 'authorization_code', 'refresh_token']
  password = 'password',
  authorization_code = 'authorization_code',
  refresh_token = 'refresh_token'
}

export enum ClientTypes {
  public = 'public',
  confidential = 'confidential',
  server = 'server'
}

type AccessOAuth = {
  resource: string;
  resource_name: string;
};

export type OauthSettings = {
  name: string;
  access: AccessOAuth[];
  project_id: string;
  redirect_uris: string[];
  secret: string;
  response_types: string[];
  id: number | null;
  client_id?: number | null;
  is_public: boolean;
  grant_types: GrantTypes[];
  lifetime: number;
};

export type OauthSettingsResponse = {
  clients: OauthSettings[];
};

export type OauthSecretKeyResponse = {
  secret: string;
};

export type OauthConnectValues = {
  grant_types: string[];
  id?: number | null;
  is_public?: boolean;
  name: string;
  project_id: string;
  redirect_uris: string[];
  response_types?: string | null;
  scopes: string[];
};

export type OauthConnectResponse = {
  secret: string;
  id: number;
};
